import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Sets the browser tab title per route (WCAG 2.4.2 Page Titled).
 *
 * Reads the `title` property from each Route definition and appends the
 * application suffix, e.g.
 *   Route title = "Dashboard"
 *   → document.title = "Dashboard | EY Statutory Audit Workflow Tool"
 *
 * When a route omits `title`, the plain product name is used so the tab
 * still has a meaningful title.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private static readonly APP_NAME = 'EY Statutory Audit Workflow Tool';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(routerState);
    this.title.setTitle(
      routeTitle
        ? `${routeTitle} | ${AppTitleStrategy.APP_NAME}`
        : AppTitleStrategy.APP_NAME
    );
  }
}
